var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00197 20C6.95299 16.5437 7.86791 14.7544 11.1377 14.17C11.1945 13.6116 11.4708 13.3064 11.9743 13.2662L12.0095 12.3263C11.5805 11.8966 11.4355 11.4447 11.506 10.9848C11.1044 10.6093 10.836 10.1534 10.7165 9.59709C10.4912 8.62709 10.6656 8.40417 11.0202 8.52266C10.8184 7.70729 10.7165 6.86582 10.7949 5.97816C11.0319 5.09652 11.4551 4.50609 12.3073 4.57437C12.5836 4.06828 13.0675 4.15062 13.5416 4C13.4554 4.09238 13.4456 4.18677 13.5004 4.28919C14.3507 3.94377 15.1285 4.25304 15.5595 4.24702C15.438 4.35145 15.3734 4.46793 15.3988 4.59847C16.9661 4.68081 17.4853 6.03038 17.0915 8.48651C17.6656 8.35597 17.3482 9.84411 16.5273 11.027C16.5665 11.6475 16.3549 12.0532 16.0434 12.3705L16.0649 13.2702C16.543 13.3225 16.8094 13.6257 16.8623 14.17C20.1321 14.7564 21.047 16.5437 20.9981 20H14H7.00197Z",
    fill: "#52596B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.44dcc1003ef43b4fccdb5237998e54bf.svg";
export { ForwardRef as ReactComponent };